<template>
  <div :class="`border rounded-lg border-grey300 px-4 py-3 mt-2 `">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["center"],
};
</script>

<style></style>
